import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  componentName = 'viewcomponent::site::parts::nursing_facilities::elderly_assistance_policies::desktop'

  open () {
    document.getElementById('elder-assistance-policy-inner').classList.remove(this.componentName + '::hidden-field')
    document.getElementById('elder-assistance-policy-close-button').classList.remove(this.componentName + '::d-none')
    document.getElementById('elder-assistance-policy-open-button').classList.add(this.componentName + '::d-none')
  }

  close () {
    document.getElementById('elder-assistance-policy-inner').classList.add(this.componentName + '::hidden-field')
    document.getElementById('elder-assistance-policy-close-button').classList.add(this.componentName + '::d-none')
    document.getElementById('elder-assistance-policy-open-button').classList.remove(this.componentName + '::d-none')
  }
}
